import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const Progress50 = createFilledIcon('Progress50', [
  [
    'path',
    {
      d: 'M21.125 12C21.125 6.9604 17.0396 2.875 12 2.875C6.9604 2.875 2.875 6.9604 2.875 12C2.875 17.0396 6.9604 21.125 12 21.125C17.0396 21.125 21.125 17.0396 21.125 12ZM22.875 12C22.875 18.0061 18.0061 22.875 12 22.875C5.9939 22.875 1.125 18.0061 1.125 12C1.125 5.9939 5.9939 1.125 12 1.125C18.0061 1.125 22.875 5.9939 22.875 12Z',
      stroke: 'none',
      key: 'Progress50-0',
    },
  ],
  [
    'path',
    {
      d: 'M12 4.5C13.9891 4.5 15.8968 5.29018 17.3033 6.6967C18.7098 8.10322 19.5 10.0109 19.5 12C19.5 13.9891 18.7098 15.8968 17.3033 17.3033C15.8968 18.7098 13.9891 19.5 12 19.5V4.5Z',
      stroke: 'none',
      key: 'Progress50-1',
    },
  ],
])

Progress50.displayName = 'Progress50'
